module.exports = __webpack_public_path__ + "img/logo.5a90a166.png";